export default __webpack_public_path__ + "static/media/logo_Bird.2cff3bf5.png";